export const ApplicationsData = [

    
	{
		title: 'scrum team health',
		to:'/gettingStartedScrumTeam',
		urlApp:'https://marketplace.atlassian.com/apps/1225156/scrum-team-health?hosting=cloud&tab=overview',
		/*price: '$7.99 user/month after offer period',*/
		/*numAcc: '50-100 accounts',*/
		features: [
            'Team velocity ',
			'Issue report :indicate the total number of finished issues by sprint',
            'Issue report story point : indicate the number of finished story points in each issue type',           
            'Time to market : indicate the average of days taken by each issue type to be done'],
	},
	{
		title: 'Issue dates overview',
		to:'gettingStartedAppIssueDates',
		urlApp:'https://marketplace.atlassian.com/apps/1225653/application-monitoring?hosting=cloud&tab=overview',
		/*price: '$32.50 user/month after offer period',*/
	    /*numAcc: '50-1000 accounts',*/
		features: [
			'Issue dates overview : monitor issues creation and due date from different project on aggregated board.'
		],
	},
	{
		title: 'gitlab monitoring',
		to:'/gettingStartedGitlabMonotoring',
		urlApp:'https://marketplace.atlassian.com/apps/1225772/gitlab-monitoring?hosting=cloud&tab=overview',
		/*price: '$18.99 user/month after offer period',*/
		/*numAcc: '50-500 accounts',*/
		features: [
			'Gitlab monitoring gadget allows you to control and monitoring Gitlab commits and versions with simple steps  ',
			
		
		],
	},
	{
		title: 'application monitoring',
		to:'gettingStartedAppMonotoring',
		urlApp:'https://marketplace.atlassian.com/apps/1225653/application-monitoring?hosting=cloud&tab=overview',
		/*price: '$32.50 user/month after offer period',*/
	    /*numAcc: '50-1000 accounts',*/
		features: [
			'Application Monitoring allows you to follow the progress of your application development with just few steps'
		],
	},









	
	


	
];
